import React, { Component } from 'react';
import classNames from 'classnames';

class InputFieldFile extends Component {
  changeHandler = (event) => {
    const {input} = this.props;
    input.onChange(event.target.files[0])
	};
  render() {
    const {disabled, meta: { touched, error }, label, style } = this.props;
    return (
      <div style={style} className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
        {label ? <label >{label}</label> : null}
        <input type="file" onChange={this.changeHandler} />
        {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
      </div>
    );
  }
}

export default InputFieldFile;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/InputFieldFile.jsx